import { Injectable } from '@angular/core';
import { ProductBacklogComponent } from './product-backlog.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Userstory } from '../../models/userstory';
import { SynchronizationService } from '../../services/synchronization.service';


@Injectable()
export class ProductBacklogSynchroHelper {
  constructor(private syncService: SynchronizationService) { }

  public initSyncEventListeners(backlog: ProductBacklogComponent) {
    this.initChangeIssueOrderSubscription(backlog);
    this.initMoveIssueToSprintBacklogSubscription(backlog);
    this.initMoveIssueToProductBacklogSubscription(backlog);
    this.initToggleProductBacklogSubscription(backlog);
  }

  private initChangeIssueOrderSubscription(backlog: ProductBacklogComponent) {
    backlog.subscriptions.push(this.syncService.subscribeEvent<any>('changeIssueOrder').subscribe(data => {
      if (data.component === 'product-backlog') {
        moveItemInArray(backlog.issues, data.indexFrom, data.indexTo);
      }
    }));
  }

  private initMoveIssueToSprintBacklogSubscription(backlog: ProductBacklogComponent) {
    backlog.subscriptions.push(this.syncService.subscribeEvent<any>('moveIssueToSprintBacklog').subscribe(data => {
      backlog.issues.splice(data.indexFrom, 1);
    }));
  }

  private initMoveIssueToProductBacklogSubscription(backlog: ProductBacklogComponent) {
    backlog.subscriptions.push(this.syncService.subscribeEvent<any>('moveIssueToProductBacklog').subscribe(data => {
      const issue: Userstory = new Userstory(null, '', undefined, 0, null,
        null, '', 1, null, data.issue.status, [], [], null, null, null, false, '', '', '', []);

      issue.update(data.issue);
      backlog.issues.push(issue);
      moveItemInArray(backlog.issues, backlog.issues.length - 1, data.indexTo);
    }));
  }

  private initToggleProductBacklogSubscription(backlog: ProductBacklogComponent) {
    backlog.subscriptions.push(this.syncService.subscribeEvent<any>('toggleProductBacklog').subscribe(data => {
      backlog.productBacklogIsOpen = data.productBacklogIsOpen;
    }));
  }
}
